type ToastType = 'success' | 'error' | 'info';

interface ToastItem {
  id: number;
  message: string;
  type: ToastType;
}

const listeners: Array<(toasts: ToastItem[]) => void> = [];
let toasts: ToastItem[] = [];
let nextId = 1;

export function subscribeToast(listener: (toasts: ToastItem[]) => void) {
  listeners.push(listener);
  return () => {
    const idx = listeners.indexOf(listener);
    if (idx !== -1) listeners.splice(idx, 1);
  };
}

function notify() {
  listeners.forEach((l) => l(toasts));
}

export function toast(message: string, type: ToastType = 'success') {
  const id = nextId++;
  toasts = [...toasts, { id, message, type }];
  notify();
  setTimeout(() => {
    toasts = toasts.filter((t) => t.id !== id);
    notify();
  }, 3500);
}
